import React, { useState } from "react";
import ObserveSize from "react-observe-size";
import { Route, Switch } from "react-router";
import { Connector } from "checkout/ts/Connector";
import { getErrorUrl } from "checkout/ts/utils/StepName";
import classnames from "classnames";
import { isMobile } from "common/utils/browser";

import { FormCheckout } from "../checkout/FormCheckout";

import { CheckoutError } from "./CheckoutError";
import { DialogHeader } from "./DialogHeader";
import { ErrorBoundary } from "./ErrorBoundary";
import { TestEnvironmentBanner } from "./TestEnvironmentBanner";
import { TestEnvironmentConfirmationWindow } from "./TestEnvironmentConfirmationWindow";

export const Dialog = () => {
    const [memorizedHeight, setMemorizedHeight] = useState(0);

    return (
        <div className={classnames("dialog", { "full-screen": isMobile() })}>
            <ObserveSize>
                {({ height }) => {
                    if (height !== memorizedHeight) {
                        setMemorizedHeight(height);
                        Connector.resizeFrame(height);
                    }

                    return (
                        <div className="dialog-content-wrapper">
                            <DialogHeader />

                            <TestEnvironmentBanner />

                            <TestEnvironmentConfirmationWindow />

                            <ErrorBoundary>
                                <Switch>
                                    <Route path={getErrorUrl()} component={CheckoutError} />

                                    <Route component={FormCheckout} />
                                </Switch>
                            </ErrorBoundary>
                        </div>
                    );
                }}
            </ObserveSize>
        </div>
    );
};
